var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"drop-decor"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/images/drop.jpg"),"alt":"水滴图案"}})]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }